import { saveUserSettings, userSettings } from '@/globals/userSettings'
import runAccessibility from './runAccessibility'
import { updateActiveIndicators, getMenuContainer } from './renderMenu'

export default function reset() {
  document?.querySelectorAll('.asw-selected')?.forEach((el) => el?.classList?.remove('asw-selected'))
  document.querySelector('.asw-amount').textContent = `100%`

  userSettings.states = {}
  runAccessibility()

  saveUserSettings()
  const menuContainer = getMenuContainer()
  if (menuContainer) updateActiveIndicators(menuContainer)
}
